import axios from "axios";


const API_URL = process.env.REACT_APP_BASEURL;
const Login_url = process.env.REACT_APP_LOGINURL;
// console.log("Login URL:-", Login_url)
// const API_URL = process.env.API_URL;

const register = (username, email, password, role_id) => {

  var newdata = {
    functionName: "AddUser",
    postData: {
      "name": username,
      "email": email,
      "password": password,
      "role_id": role_id
    },
  }
  return axios.post(API_URL + "settings", newdata);
  // return axios.post(API_URL + "signup", {
  //   username,
  //   email,
  //   password,
  // });
};

//Commented because system use redux / auth reducer to manage login
// const login = (username, password) => {
//   var logindata = {
//     functionName: "LoginUser",
//     postData: {
//       "email": username,
//       "password": password,
//     },
//   }

//   return axios
//     .post(Login_url + "login/", logindata)
//     .then((response) => {
//       console.log("ADMIN_LOGIN]: " , response);
//       if (response.data.status) {
//         // if (response.data.accessToken) {
//         var user_data = response.data.userData;
//         console.log("[ADMIN_LOGIN] Server returned userData:", user_data);
//         console.log("[ADMIN_LOGIN] Server returned user_type:", user_data?.user_type);
//         console.log("[ADMIN_LOGIN] Before auth.service sets user_type, localStorage value:", localStorage.getItem("user_type"));
//         user_data['username'] = user_data.email;
//         user_data['accessToken'] = user_data._id;
//         user_data['session-id'] = response.data.sessionID;
//         user_data['roles'] = [
//           "ROLE_ADMIN",
//           "ROLE_USER"
//         ];
//         console.log("Login Response:-", response)
//         localStorage.setItem("user", JSON.stringify(user_data));
//         localStorage.setItem("session-id", response.data.sessionID);
//         if (user_data && user_data.user_type) {
//           console.log("[ADMIN_LOGIN] Overwriting user_type with server value:", user_data.user_type);
//           localStorage.setItem("user_type", user_data.user_type);
//         } else {
//           console.log("[ADMIN_LOGIN] Server did NOT return user_type. Keeping existing value:", localStorage.getItem("user_type"));
//         }
//         console.log("[ADMIN_LOGIN] Final user_type value in localStorage:", localStorage.getItem("user_type"));
//       }
//       // return response.data;
//       console.log("User Data:-", user_data);
//       return user_data;
//     });
// };

const logout = () => {
  // localStorage.removeItem("user");
  const userType = localStorage.getItem("user_type");
  const logo = localStorage.getItem("system_logo");
  const buttons_color = localStorage.getItem("buttons_color");
  const topbar_color = localStorage.getItem("topbar_color");
  const leftbar_color = localStorage.getItem("leftbar_color");
  const buttons_text_color = localStorage.getItem("buttons_text_color");
  const language = localStorage.getItem("language");

  localStorage.clear();
  localStorage.setItem("system_logo", logo);
  localStorage.setItem("buttons_color", buttons_color);
  localStorage.setItem("topbar_color", topbar_color);
  localStorage.setItem("leftbar_color", leftbar_color);
  localStorage.setItem("buttons_text_color", buttons_text_color);
  localStorage.setItem("language", language);

  var logindata = {
    functionName: "LogoutUser",
    postData: {
      // "email": username,
      // "password": password,
      // "resetcode": resetcode
    },
  }

  return axios
    // return axios.post(API_URL+"logout/")  
    .post(API_URL + "logout/", logindata)
    .then((response) => {
      return response.data;
    });
};

const pwresetreq = (username) => {

  var logindata = {
    functionName: "GetResetCode",
    postData: {
      "email": username,
    },
  }

  return axios
    .post(Login_url + "forgotpassword/", logindata)
    .then((response) => {

      // if (response.data.status) {
      // if (response.data.accessToken) {
      // var user_data = response.data.userData;
      // }

      // console.log(response.headers);
      //   console.log(response.request);
      //   console.log(response.config);
      //   console.log(response.data);

      // return response.data;
      // console.log(user_data);
      return response;
    });
};

const resetpw = (username, password, resetcode) => {

  var logindata = {
    functionName: "ResetPassowrd",
    postData: {
      "email": username,
      "password": password,
      "resetcode": resetcode
    },
  }

  return axios.post(Login_url + "forgotpassword/", logindata)
  // .then((response) => {

  //   if (response.data.status) {
  //     var user_data = response.data.userData;
  //   }
  //   console.log(user_data);
  //   return user_data;
  // });
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};


const Update_User = (payload) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  }
  // Use the settings endpoint with UpdateCustomerProfile function for customer profile updates
  const settingsPayload = {
    functionName: 'UpdateCustomerProfile',
    postData: payload
  };
  return axios.post(Login_url + 'settings', settingsPayload, { headers });
};
const Register_Doctor = (payload) => {

  return axios.post(Login_url + "UserModule/Register_Doctor", payload, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
};
const AuthService = {
  register,
  // login,
  Update_User,
  logout,
  Register_Doctor,
  pwresetreq,
  resetpw,
  getCurrentUser,
}

export default AuthService;
